import { Text } from '~/components/atomic';
import * as S from '../Terms.styled';

export default function PersonalInfo() {
  return (
    <S.Container>
      <Text as={'h1'} fontStyle='title.section24_bold' color='content_light_2'>
        [Consent to Collection and Use of Personal Information for Membership
        and Use of Services]
      </Text>

      <S.Desc>
        Company collects and process your personal information as follows.
        Please read the following carefully and choose whether you agree or not.
      </S.Desc>
      <S.Article>
        <S.ArticleContent>
          <p>
            Company collects and process your personal information as follows.
            Please read the following carefully and choose whether you agree or
            not.
          </p>
          <S.Table>
            <thead>
              <tr>
                <th>Intended Purpose</th>
                <th>Information Collected</th>
                <th>Period of Retention and Use</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Signing up and member management Service delivery</td>
                <td>
                  Name, email account, password, phone number, occupation,
                  gender, date of birth, and credentials for easy sign-in
                </td>
                <td>
                  Until the data subject stops using the Services
                  <br />
                  <br />
                  However, (1) in the event of an ongoing investigation in
                  violation of relevant laws and regulations, the records shall
                  be retained until the end of such proceedings; (2) in the
                  event of a debt or liability due to the use of the Services,
                  the records shall be retained until the settlement of such
                  debt or liability, and (3) records of displayed advertisements
                  shall be retained for at least six months in accordance with
                  the Electronic Commerce Act.
                </td>
              </tr>
            </tbody>
          </S.Table>
          <p>
            You may refuse to give a consent to disclosure of the personal
            information, in which case you will not unable to receive the
            relevant services.
          </p>
        </S.ArticleContent>
      </S.Article>
    </S.Container>
  );
}
